import { isQuestScheduledForDate } from './questScheduleDate';

const isWorkoutQuest = (quest) => Boolean(quest?.type && /Workout/i.test(quest.type));

export const isQuestWithinSnapshotUtcRange = (quest, snapshotDate) => {
  if (!quest?.start || !snapshotDate) {
    return false;
  }

  const questStart = new Date(quest.start);
  const snapshotStart = new Date(snapshotDate);
  if (Number.isNaN(questStart.getTime()) || Number.isNaN(snapshotStart.getTime())) {
    return false;
  }

  const snapshotEnd = new Date(snapshotStart);
  snapshotEnd.setUTCDate(snapshotEnd.getUTCDate() + 1);
  snapshotEnd.setUTCMilliseconds(-1);

  return questStart >= snapshotStart && questStart <= snapshotEnd;
};

export const findWorkoutQuestForSnapshotDay = ({
  quests = [],
  snapshotDate,
  fallbackTimezone = 'UTC',
} = {}) => {
  const workoutQuests = (Array.isArray(quests) ? quests : []).filter(isWorkoutQuest);
  if (!snapshotDate || workoutQuests.length === 0) {
    return null;
  }

  const scheduledMatch = workoutQuests.find((quest) =>
    isQuestScheduledForDate(quest, snapshotDate, fallbackTimezone)
  );
  if (scheduledMatch) {
    return scheduledMatch;
  }

  return workoutQuests.find((quest) =>
    isQuestWithinSnapshotUtcRange(quest, snapshotDate)
  ) || null;
};

export const resolveWorkoutTargetKcal = ({
  quests = [],
  snapshotDate,
  fallbackTimezone = 'UTC',
} = {}) => {
  const workoutQuest = findWorkoutQuestForSnapshotDay({
    quests,
    snapshotDate,
    fallbackTimezone,
  });

  const estimatedCalories = workoutQuest?.detailedDescription?.estimatedCalories;
  if (typeof estimatedCalories !== 'number' || !Number.isFinite(estimatedCalories) || estimatedCalories <= 0) {
    return null;
  }

  return Math.round(estimatedCalories);
};
